import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgProductElectrical = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.58137 20.7542L11.3333 13.9775L4 13.0888L14.8519 3H16.3061L12.5091 9.78584L19.8695 10.6654L9.01756 20.7542H7.58137ZM11.4967 16.4711L16.7262 11.7011L10.2869 10.9345L12.3765 7.27963L7.14333 12.0584L13.5593 12.8375L11.4967 16.4711Z",
		fill: "currentColor"
	})
});
export default SvgProductElectrical;
